import { IconProps } from './IconProps'

export function WhatsAppIcon(props: IconProps) {
  const size = props.size || 24

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.9836 11.4102C21.6436 5.61036 16.3743 1.14047 10.3051 2.14045C6.12561 2.83043 2.77605 6.22034 2.12614 10.4002C1.74618 12.8202 2.24614 15.1102 3.336 17.0001L2.4461 20.31C2.24613 21.06 2.93602 21.74 3.67592 21.53L6.93551 20.63C8.41532 21.5 10.1451 22 11.9949 22C17.6341 22 22.3135 17.0301 21.9836 11.4102ZM16.8842 15.7201C16.7942 15.9001 16.6842 16.0701 16.5443 16.2301C16.2943 16.5001 16.0243 16.7001 15.7244 16.8201C15.4244 16.9501 15.0945 17.0101 14.7445 17.0101C14.2346 17.0101 13.6846 16.8901 13.1147 16.6401C12.5348 16.3901 11.9649 16.0601 11.395 15.6501C10.815 15.2301 10.2751 14.7602 9.75515 14.2502C9.23522 13.7302 8.77526 13.1802 8.35531 12.6102C7.94536 12.0402 7.61543 11.4702 7.37546 10.9002C7.13549 10.3302 7.01552 9.78028 7.01552 9.26029C7.01552 8.92029 7.0755 8.5903 7.19549 8.29031C7.31547 7.98031 7.50546 7.70032 7.77543 7.45033C8.09539 7.13034 8.44532 6.98034 8.81527 6.98034C8.95525 6.98034 9.09521 7.01033 9.22519 7.07033C9.35518 7.13033 9.47519 7.22033 9.56518 7.35033L10.725 8.99027C10.815 9.12027 10.885 9.23027 10.925 9.34027C10.975 9.45027 10.995 9.55026 10.995 9.65026C10.995 9.77026 10.955 9.89027 10.885 10.0103C10.815 10.1303 10.725 10.2503 10.605 10.3702L10.2251 10.7702C10.1651 10.8302 10.1451 10.8902 10.1451 10.9702C10.1451 11.0102 10.1551 11.0502 10.1651 11.0902C10.1851 11.1302 10.1951 11.1602 10.2051 11.1902C10.2951 11.3602 10.455 11.5702 10.675 11.8302C10.905 12.0902 11.145 12.3602 11.405 12.6202C11.6749 12.8902 11.9349 13.1302 12.2048 13.3602C12.4648 13.5802 12.6847 13.7302 12.8547 13.8202C12.8847 13.8302 12.9147 13.8502 12.9447 13.8602C12.9847 13.8802 13.0247 13.8802 13.0747 13.8802C13.1647 13.8802 13.2247 13.8502 13.2847 13.7902L13.6646 13.4102C13.7946 13.2802 13.9146 13.1902 14.0246 13.1302C14.1446 13.0602 14.2546 13.0202 14.3846 13.0202C14.4845 13.0202 14.5845 13.0402 14.6945 13.0902C14.8045 13.1402 14.9245 13.2002 15.0444 13.2902L16.7043 14.4702C16.8342 14.5602 16.9242 14.6702 16.9842 14.7902C17.0342 14.9202 17.0642 15.0401 17.0642 15.1801C17.0042 15.3501 16.9642 15.5401 16.8842 15.7201Z'
        fill='url(#paint0_linear_885_257265)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_885_257265'
          x1='2.99987'
          y1='21.4996'
          x2='18.4998'
          y2='3.50162'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00CD1A' />
          <stop offset='1' stopColor='#00F14A' />
        </linearGradient>
      </defs>
    </svg>
  )
}
